// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__NYwMt","Label":"Input_Label__2PuZY","InputElement":"Input_InputElement__2CXoK","Invalid":"Input_Invalid__3foIT"};